import { render, staticRenderFns } from "./beneficiary-project-manager.vue?vue&type=template&id=413a2412&"
import script from "./beneficiary-project-manager.vue?vue&type=script&lang=js&"
export * from "./beneficiary-project-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports